/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }
/*============================================================================
  Handlebars helpers
==============================================================================*/
/*

Handlebars.registerHelper('is_gift_note', function (sourceString, options) {
  var gift_note_products_handles = "";
  if (gift_note_products_handles.indexOf("_"+sourceString+"_") != -1) {
    return options.fn(this);
  }
  return options.inverse(this);
});

Handlebars.registerHelper('options', function () {
  var result = [];
  var selectedOptions = this.options;
  var itemProperties = this.properties;
  var personalised_2_0 = false;

  for (var key in itemProperties) {
     if (itemProperties.hasOwnProperty("p id")) {
        personalised_2_0 = true;
     }
  }


  selectedOptions.forEach(function(option) {
    //show size results
    if (option.name.toLowerCase() == 'size' ) {
      var size = option.value;
      if(
        size.includes('0-') || 
        size.includes('2-') ||
        size.includes('3-') || 
        size.includes('6-') ||
        size.includes('9-') ||
        size.includes('12-')||
        size.includes('18-')
        ) {
        var res = size.split('-').join(' - ');
        result.push("Size: " + res);
      } else {
        result.push("Size: " + size);
      }
    }
      //show personalized options
    if(option.name.toLowerCase() == 'personalisation' || 'personalization'){
      var personalisation = option.value;
      if (personalisation.toLowerCase() == 'yes' || personalised_2_0) {
        result.push("Personalised");
      }
      if (personalisation.toLowerCase() == "no" && personalised_2_0 == false) {
        result.push("Non personalised");
      }
    }

  });

  var uniqueArray = function() {
    return result.filter(function(elem, pos,arr) {
      return arr.indexOf(elem) == pos;
    });
  }

  return new Handlebars.SafeString(uniqueArray().join("<br>"));

});
*/
/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  console.log("onCartUpdate LINE: 105");
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  console.log("updateCartNote LINE: 110");
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeUpdateCartNote.ajaxCart', note);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  console.log("addItemFromForm LINE: 153");
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    beforeSend: function(jqxhr, settings) {
      $body.trigger('beforeAddItem.ajaxCart', form);
    },
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
      $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
      document.body.dispatchEvent(new CustomEvent('cart.updated'));
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
      $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  console.log("getCart LINE: 190");
  $(document.body).trigger('beforeGetCart.ajaxCart');
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
    $(document.body).trigger('afterGetCart.ajaxCart', cart);
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback, $row) {
  console.log("CHANGE ITEM");
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
    },
    success: function(cart) {
      
      if ((typeof callback) === 'function') {
        callback(cart);
      } else if ((typeof callback) === 'string') {
        if(callback == "refetch cart") {
          // temporary fix a racing condition bug where the cart total is comes back before the product quantity is changed  
          jQuery.getJSON('/cart.js', function (refetched_cart) {
            console.log(refetched_cart);
            var money_format = "${{amount}}";
            $(".cart_drawer_subtotal money").html(Shopify.formatMoney(refetched_cart.total_price, money_format));
          });
        }
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      // console.log(" LINE: cart ", cart);
      if( $row !== undefined ) {
        var wrapping_id = $row.attr("data-wrapping");
        var personalisation_id = $row.attr("data-personalisation");

        if( wrapping_id != undefined ) {

          var attached_wrapping = $(".ajaxcart__row[data-product='"+wrapping_id+"']");
          var w_line = attached_wrapping.attr("data-line");

          ShopifyAPI.changeItem(w_line, quantity, null);
        }

        // auto-increase personalisation product quantity
        if( personalisation_id != undefined ) {
          var attached_personalisation = $(".ajaxcart__row[data-product='"+personalisation_id+"']");
          var p_line = attached_personalisation.attr("data-line");

          ShopifyAPI.changeItem(p_line, quantity, "refetch cart"); 
        }
      }


      $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty;

  var blanket_offer_new_cust_spend = parseInt($("meta[name='blanket_offer_new_customers_spend']").attr("content"));
  
  var greeting_cards = $("meta[name='greeting_cards']").attr('content');

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : 'input[type="submit"]',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);

    // General Selectors
    $body = $(document.body);

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    // adjustCart();
  };

  loadCart = function () {
    $body.addClass('drawer--is-loading');
    console.log("loadCart: LINE: 340");
    ShopifyAPI.getCart(cartUpdateCallback);
  };
/*
  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };*/

  formOverride = function () {
    $formContainer.on('submit', function(evt) {
      evt.preventDefault();

      // Add class to be styled if desired
      // $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      // $('.qty-error').remove();

      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
  };

  itemAddedCallback = function (product) {
    $addToCart.removeClass('is-adding').addClass('is-added');
    console.log(" LINE: 373");
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };

  cartUpdateCallback = function (cart) {
    console.log("cartUpdateCallback: LINE: 389");
    // Update quantity and price
    // updateCountPrice(cart);
    // cartCallback(cart);
  };

 /* buildCart = function (cart) {
    console.log("buildCart: LINE: 396");
    // Start with a fresh cart div
    // $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
      $cartContainer
        .append('<p>' + "Your cart is currently empty." + '</p>');
      cartCallback(cart);
      return;
    }*/

    // Handlebars.js cart layout
    /*,
    var items = [],
        item = {},
        data = {}
        source = $("#CartTemplate").html()
        // ,template = Handlebars.compile(source);

    var default_personalisation_product_price = parseInt(LiquidVarPersonalisationPrice.price);
    var default_personalisation_product_handle = LiquidVarPersonalisationPrice.handle;
    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {

      /*var placeholderImage = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      
      if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
      } else {
        var prodImg = placeholderImage;
      }

      cartItem.properties = cartItem.properties || {};

      // Create item's data object and add to 'items' array
      item = {
        id: cartItem.variant_id,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        handle: cartItem.handle,
        options: cartItem.options_with_values,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
        vendor: cartItem.vendor,
        linePrice: Shopify.formatMoney(cartItem.line_price, settings.moneyFormat),
        originalPrice: Shopify.formatMoney((cartItem.line_price + cartItem.total_discount), settings.moneyFormat), 
        discounts: cartItem.discounts,
        discountsApplied: cartItem.line_price === (cartItem.line_price - cartItem.total_discount) ? false : true,
        isSleepclubUpsell: Object.keys(cartItem.properties).some(function(key) { return key === 'Display as' && cartItem.properties[key] === "product" }),
        discountRule: cartItem.properties['Discount'] ? cartItem.properties['Discount']: false,
        freeBlanketApplied: cartItem.properties['£1 blanket'] ? true : false,
        message: null,
        is_default_personalised_product: cartItem.handle === default_personalisation_product_handle ? true: false,
        does_hide_quantity_selectors: doesHideQuantitySelectors(cartItem)
      };

      function doesHideQuantitySelectors(cartItem) {
        var is_true = false;
        // check if an item is inside the collection of greeting cards
        if (greeting_cards.indexOf("|"+cartItem.handle+"|") != -1) {
          is_true = true;
        }
        return is_true;
      }

      if(cartItem.properties['p id']){
        item.linePrice = Shopify.formatMoney((cartItem.price + default_personalisation_product_price) * cartItem.quantity, settings.moneyFormat);
        item.originalPrice = Shopify.formatMoney(cartItem.price + default_personalisation_product_price, settings.moneyFormat);
      }

      if((item.name.toLowerCase().includes("membership") || item.name.toLowerCase().includes("subscription")) && !item.name.toLowerCase().includes("gift")){
        if(item.name.toLowerCase().includes("annual")){
          item.properties.subscription_id = item.properties.subscription_id || "118025";
        }
        if(item.name.toLowerCase().includes("monthly")){
          item.properties.subscription_id = item.properties.subscription_id || "73617";
        }
        item.properties.shipping_interval_frequency  = item.properties.shipping_interval_frequency || "30";
        item.properties.shipping_interval_unit_type = item.properties.shipping_interval_unit_type =  "Days";
        //update properties https://shopify.dev/docs/themes/ajax-api/reference/cart#post-cart-change-js
        jQuery.post('/cart/change.js', { line: item.line, properties: item.properties });
      }

      if (item.isSleepclubUpsell) {
        var variantImage = cartItem.properties['Display image'];
        var productTitle = cartItem.properties['Display title'];
        var variantTitle = cartItem.properties['Display variant title'];


        item.img = (variantImage && variantImage !== 'n/a') ? variantImage : placeholderImage;
        item.name = productTitle;
        item.variation = variantTitle;
        item.handle = item.handle.replace('sleepclub', ''); // To avoid the sleep club template
      }

      if (Object.keys(cartItem.properties).some(key => key === "Donation product")) {
          item.url = "https://babymori.com/pages/nhs-donations";
          item.message = "Thank you so much for your donation!";
      }console.log(item);
      console.log( "discountRule:", cartItem.properties['Discount']);items.push(item);
    });
    */

    /*
    var isUkStore = window.location.href.indexOf("minimori.com") === -1 && window.location.href.indexOf("babymoriusa") === -1;
    var newFreeBlanketMinSpend = blanket_offer_new_cust_spend;
    var newFreeBlanketProductName = ""
    if (!newFreeBlanketMinSpend) {
      newFreeBlanketMinSpend = 35;
    }
    if (!newFreeBlanketProductName) {
      newFreeBlanketProductName = "MORI Blanket";
    }
    var cur_symb = $("meta[name='shop-currency-code']").attr("content");
    if(cur_symb == "GBP") {
      cur_symb = "£";
    } else {
      cur_symb = "$";
    }

    var minSpendWithCurrency = cur_symb + newFreeBlanketMinSpend;

    

    var cart_total = cart.total_price;

    var free_blanket_is_in_cart = false;
    
    for (var item = 0; item < cart.items.length; item++) {
      for (var key in cart.items[item].properties) {
        if (key === 'Gift') {
          free_blanket_is_in_cart = true;
          cart_total -= cart.items[item].final_price
        }
      };
    };

    var invalidMessage_pt_1 = '<br><p class="text-center" style="color: red;">Please spend <span class="money">';
    var invalidMessage_pt_2 = '</span> to qualify for your free ';
    var invalidMessage_pt_3 = '</p>';

    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      gift: {
        present: items.filter(function (item) {
          return Object.keys(item.properties).indexOf('Gift') !== -1;
        }).length > 0,
        valid: !((cart_total) < (newFreeBlanketMinSpend * 100)),
        invalidMessage: invalidMessage_pt_1 + minSpendWithCurrency + invalidMessage_pt_2 + newFreeBlanketProductName + invalidMessage_pt_3
      },
      totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
      totalCartDiscount: cart.total_discount === 0 ? 0 : "You're saving [savings]".replace('[savings]', Shopify.formatMoney(cart.total_discount, settings.moneyFormat)),
      totalCartDiscountApplied: cart.total_discount === 0 ? false : true
    }

    // $cartContainer.append(template(data));


    var shop_currency = $("meta[name='shop-currency-code']").attr("content");
    var cart_currency = $("meta[name='cart-currency-code']").attr("content");
    var is_foreign_currency = (shop_currency != cart_currency);


    // only if the cart currency is different -- get the exchange rate and adjust the minimum spend message 
    // doing it after the cart drawer template was appended so that ajax call doesnt delay showing the drawer contents

    if(free_blanket_is_in_cart && is_foreign_currency) {
      
      $.ajax({
        type: 'GET',
        url: 'http://www.floatrates.com/daily/' + shop_currency + '.xml',
        dataType: 'xml',
        success: function(xml) {
          // get the xml parent item of a current currency code
          var xml_item = $(xml)
            .find("item targetCurrency:contains('" + cart_currency + "')")
            .closest('item');
          var exchange_rate = parseFloat(xml_item.find('exchangeRate').text());

          newFreeBlanketMinSpend = (newFreeBlanketMinSpend * exchange_rate).toFixed(2);

          if((cart_total) < (newFreeBlanketMinSpend * 100)) {
            cur_symb = $("meta[name='cart-currency-symbol']").attr("content");
            minSpendWithCurrency = cur_symb + newFreeBlanketMinSpend;

            if ($("#CartContainer #minSpend").length == 0) {
              $("#CartContainer .continue").after("<div id='minSpend'></div>");
              $("#CartContainer .ajaxcart__savings").remove();
            }

            $("#CartContainer #minSpend").html(invalidMessage_pt_1 + minSpendWithCurrency + invalidMessage_pt_2 + newFreeBlanketProductName + invalidMessage_pt_3);
          }

        },
        error: function(error) {
          console.log('Something is wriong with the currency rate query');
          console.log(error);
        },
      });

    }


    cartCallback(cart);
  };*/

  // cartCallback = function (cart) {
  //   console.log("cartCallback: line: 625")
  //   $body.removeClass('drawer--is-loading');
  //   $body.trigger('afterCartLoad.ajaxCart', cart);
  // };
/*
  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    /*$body.on('click', '.ajaxcart__qty-adjust', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });
    /*
    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback, $row);
      }, 250);
    }
    
    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    console.log(" LINE: 711");
    // Update quantity and price
    // updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      isUpdating = false;
      console.log(" LINE: 721");
      ShopifyAPI.getCart(buildCart);
    }, 150)
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            currentQty = $el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };
*/
  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    // var numInputs = $('input[type="number"]');
    var numInputs = $('#CartDrawer input[type="number"], .cart-wrapper input[type="number"]');


    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 0) qty = 0;
        }

        // Update the input's number
        $qtySelector.val(qty);
      });
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart
  };

  return module;

}(ajaxCart || {}, jQuery));
